module.exports = __webpack_public_path__ + "static/media/elec-white.0abe8bb7.svg";